import * as turf from '@turf/turf';

const getPolygonFeatures = (value) => {
    if (!value) return [];
    if (value.type === 'FeatureCollection') return value.features || [];
    if (Array.isArray(value)) return value;
    return [value];
};

const getOuterCoordinates = (polygon) => {
    const features = getPolygonFeatures(polygon);
    const coordinates = [];
    features.forEach(feature => {
        const geometry = feature && feature.type === 'Feature' ? feature.geometry : feature;
        if (!geometry) return;
        if (geometry.type === 'Polygon' && geometry.coordinates && geometry.coordinates[0]) {
            coordinates.push(...geometry.coordinates[0]);
        } else if (geometry.type === 'MultiPolygon' && Array.isArray(geometry.coordinates)) {
            geometry.coordinates.forEach(item => {
                if (item && item[0]) coordinates.push(...item[0]);
            });
        }
    });
    return coordinates;
};

const toMercatorCoordinate = (coordinate) => turf.toMercator(turf.point(coordinate)).geometry.coordinates;
const toWgs84Coordinate = (coordinate) => turf.toWgs84(turf.point(coordinate)).geometry.coordinates;

const makePlanningFrame = (polygon, ab) => {
    if (!Array.isArray(ab) || ab.length < 2) return null;
    const outerCoordinates = getOuterCoordinates(polygon);
    const first = toMercatorCoordinate(ab[0]);
    const second = toMercatorCoordinate(ab[1]);
    const dx = second[0] - first[0];
    const dy = second[1] - first[1];
    const length = Math.hypot(dx, dy);
    const vertices = outerCoordinates.map(toMercatorCoordinate);
    if (!length || vertices.length < 3) return null;

    const u = [dx / length, dy / length];
    const n = [-u[1], u[0]];
    const project = (point, axis) => point[0] * axis[0] + point[1] * axis[1];
    const along = vertices.map(point => project(point, u));
    const across = vertices.map(point => project(point, n));
    const latitudes = outerCoordinates.map(point => point[1]);
    const midLat = (Math.min(...latitudes) + Math.max(...latitudes)) / 2;
    const mercatorScale = 1 / Math.max(0.01, Math.cos(midLat * Math.PI / 180));

    return {
        u,
        n,
        project,
        minAlong: Math.min(...along),
        maxAlong: Math.max(...along),
        minAcross: Math.min(...across),
        maxAcross: Math.max(...across),
        mercatorScale
    };
};

const makeLineAtProjection = (frame, across, extension = 1) => {
    const startAlong = frame.minAlong - extension;
    const endAlong = frame.maxAlong + extension;
    const pointAt = along => [
        frame.u[0] * along + frame.n[0] * across,
        frame.u[1] * along + frame.n[1] * across
    ];
    return turf.lineString([
        toWgs84Coordinate(pointAt(startAlong)),
        toWgs84Coordinate(pointAt(endAlong))
    ]);
};

const splitLineByPolygon = (line, polygon, intersectionCount) => {
    let split = [];
    try {
        split = turf.lineSplit(line, polygon).features;
    } catch (e) {
        split = [];
    }
    if (intersectionCount <= 1 || (split.length >= intersectionCount + 1 && split.length !== 2)) return split;

    const pivot = turf.center(line).geometry.coordinates;
    [0.15, -0.15].some(angle => {
        try {
            const rotated = turf.transformRotate(line, angle, { pivot });
            const candidate = turf.lineSplit(rotated, polygon).features;
            if (candidate.length >= intersectionCount + 1 && candidate.length !== 2) {
                split = candidate;
                return true;
            }
        } catch (e) {
        }
        return false;
    });
    return split;
};

const getLinePiecesInsidePolygon = (line, polygon) => {
    const features = getPolygonFeatures(polygon);
    const pieces = [];

    features.forEach(feature => {
        if (!feature || !feature.geometry) return;
        const border = turf.polygonToLine(feature);
        const intersections = turf.lineIntersect(line, border).features.length;
        let split = [];

        if (intersections > 1) {
            split = splitLineByPolygon(line, feature, intersections);
        }

        if (split.length === 0) {
            const middle = turf.along(line, turf.length(line) / 2);
            if (turf.booleanPointInPolygon(middle, feature, { ignoreBoundary: false })) split = [line];
        }

        split.forEach(piece => {
            const middle = turf.along(piece, turf.length(piece) / 2);
            const lengthKm = turf.length(piece, { units: 'kilometers' });
            if (lengthKm > 0.0005 && turf.booleanPointInPolygon(middle, feature, { ignoreBoundary: false })) {
                pieces.push(piece);
            }
        });
    });

    return pieces;
};

const removeExclusionPieces = (lines, exclusions) => {
    let pieces = lines;
    getPolygonFeatures(exclusions).forEach(exclusion => {
        if (!exclusion || !exclusion.geometry) return;
        const border = turf.polygonToLine(exclusion);
        const nextPieces = [];
        pieces.forEach(line => {
            let split = [];
            const intersections = turf.lineIntersect(line, border).features.length;
            if (intersections > 0) {
                split = splitLineByPolygon(line, exclusion, intersections);
            }
            if (split.length === 0) split = [line];
            split.forEach(piece => {
                const middle = turf.along(piece, turf.length(piece) / 2);
                const lengthKm = turf.length(piece, { units: 'kilometers' });
                if (lengthKm > 0.0005 && !turf.booleanPointInPolygon(middle, exclusion, { ignoreBoundary: false })) {
                    nextPieces.push(piece);
                }
            });
        });
        pieces = nextPieces;
    });
    return pieces;
};

class Tools {
    teste = () => {
        return 'Hello!';
    }

    //ajusta a ordem de acordo com o tipo
    orderPath = (linhas, line, type, lado, options) => {
        if (this.isCentralPlanningStrategy(type) && options && options.centerMirror) linhas = linhas.slice().reverse();
        let newLines = [];
        if (type === 'BACKTOBACK') {
            newLines = linhas;

        } else if (type === 'SKIPBACKTOBACK') {
            const orderKey = item => item.planningIndex === undefined ? item.key : item.planningIndex;
            let odd = linhas.filter(item => Math.abs(orderKey(item) % 2) === 1);
            let even = linhas.filter(item => orderKey(item) % 2 === 0);
            if (line % 2 === 0) {
                newLines = odd.concat(even);
            } else {
                newLines = even.concat(odd);
            }

        } else if (type === 'QUICKRACETRACK') {
            let half = Math.ceil(linhas.length / 2);
            for (let i = 0; i < half; i++) {
                newLines.push(linhas[i]);
                if (linhas.length > (half + i)) {
                    newLines.push(linhas[half + i]);
                }
            }
        } else if (type === 'RACETRACK') {
            const loopWidth = Number(options && options.size_loop);
            const lineWidth = Number(options && options.size_line);
            if (!Number.isFinite(loopWidth) || loopWidth <= 0 || !Number.isFinite(lineWidth) || lineWidth <= 0 || (loopWidth * 2) >= (linhas.length * lineWidth)) {
                newLines = this.orderPath(linhas, line, 'QUICKRACETRACK', lado);
            } else {
                const linesPerSide = Math.max(1, Math.ceil(loopWidth / lineWidth));
                const groupSize = linesPerSide * 2;
                const part = Math.floor(linhas.length / groupSize);

                if (part <= 0) {
                    newLines = this.orderPath(linhas, line, 'QUICKRACETRACK', lado);
                } else {
                    let ret = [];
                    let final = -1;
                    for (let i = 1; i <= part; i++) {
                        let fim = (i * groupSize) - 1;
                        let ini = fim + 1 - groupSize;
                        final = fim;

                        let temp_lines = linhas.slice(ini, fim + 1);
                        ret = ret.concat(this.orderPath(temp_lines, line, (ret.length > 0 ? 'REVERSERACETRACK' : 'QUICKRACETRACK'), lado));
                    }
                    let rest = linhas.slice(final + 1, linhas.length);
                    newLines = ret.concat(this.orderPath(rest, line, 'REVERSERACETRACK', lado));
                }
            }
        } else if (type === 'REVERSERACETRACK') {
            let half = Math.ceil(linhas.length / 2);
            let start = parseInt(linhas.length / 2);
            for (let i = 0; i < half; i++) {
                newLines.push(linhas[start + i]);
                if (i < start) {
                    newLines.push(linhas[i]);
                }
            }
        } else if (type === 'EXPAND') {
            let size = linhas.length;
            let half = Math.ceil(linhas.length / 2);
            for (let i = 0; i < half; i++) {
                if (line % 2 === 0) {
                    newLines.push(linhas[(size - half) + i]);
                }
                if (size - i > half) {
                    newLines.push(linhas[(size - half - 1) - i]);
                }
                if (line % 2 !== 0) {
                    newLines.push(linhas[(size - half) + i]);
                }
            }
        } else if (type === 'SQUEEZE') {
            let size = linhas.length;
            let half = Math.ceil(linhas.length / 2);
            for (let i = 0; i < half; i++) {
                newLines.push(linhas[i]);
                if (size - i > half) {
                    newLines.push(linhas[linhas.length - 1 - i]);
                }
            }
        } else if (type === 'PIVOTRACETRACK') {
            linhas.reverse();
            let leftPath = linhas.filter((a, i) => (i >= Math.floor(linhas.length / 2)));
            newLines = this.orderPath(leftPath, line, 'RACETRACK');
            let rightPath = linhas.filter((a, i) => (i < Math.floor(linhas.length / 2)));
            rightPath.reverse();
            newLines = newLines.concat(this.orderPath(rightPath, line, 'RACETRACK'));
        }

        return newLines;
    }

    createPlanningABPair = (polygon, edgeAB, faixa, space = 0) => {
        if (edgeAB && !Array.isArray(edgeAB) && Array.isArray(edgeAB.c)) edgeAB = edgeAB.c;
        const frame = makePlanningFrame(polygon, edgeAB);
        const width = Number(faixa);
        if (!frame || !Number.isFinite(width) || width <= 0) return null;

        const limit = Math.max(0, width / 2);
        const offset = Math.min(limit, Math.max(-limit, Number(space) || 0));
        const source = edgeAB.map(toMercatorCoordinate);
        const sourceAcross = (frame.project(source[0], frame.n) + frame.project(source[1], frame.n)) / 2;
        const centerAcross = (frame.minAcross + frame.maxAcross) / 2;
        const fromMinimum = sourceAcross <= centerAcross;
        const direction = fromMinimum ? 1 : -1;
        const edgeAcross = fromMinimum ? frame.minAcross : frame.maxAcross;
        const initialAcross = edgeAcross + direction * (width / 2 + offset) * frame.mercatorScale;
        const mirroredAcross = frame.minAcross + frame.maxAcross - initialAcross;

        const pair = {
            initialAB: { c: makeLineAtProjection(frame, initialAcross).geometry.coordinates, line: 0 },
            mirroredAB: { c: makeLineAtProjection(frame, mirroredAcross).geometry.coordinates, line: 0 }
        };
        const lines = this.createPlanningLines(polygon, pair, 0, width);
        return Object.assign(pair, this.createPlanningCenterABs(lines, pair.initialAB));
    };

    isCentralPlanningStrategy = type => type === 'EXPAND' || type === 'REVERSERACETRACK';

    createPlanningLineAB = (line, reference) => {
        if (!line || !line.linhas || !reference || !Array.isArray(reference.c)) return null;
        const coordinate = turf.coordAll(line.linhas)[0];
        if (!coordinate) return null;
        const [a, b] = reference.c.map(toMercatorCoordinate);
        const dx = b[0] - a[0];
        const dy = b[1] - a[1];
        const length = Math.hypot(dx, dy);
        if (!length) return null;

        const normal = [-dy / length, dx / length];
        const point = toMercatorCoordinate(coordinate);
        const offset = (point[0] - a[0]) * normal[0] + (point[1] - a[1]) * normal[1];
        return {
            c: [a, b].map(value => toWgs84Coordinate([value[0] + normal[0] * offset, value[1] + normal[1] * offset])),
            line: line.planningIndex === undefined ? Math.abs(Number(line.key)) : line.planningIndex
        };
    };

    createPlanningCenterABs = (lines, reference) => {
        const centers = { centerAB: null, centerAB1: null, centerAB2: null };
        if (!Array.isArray(lines) || lines.length === 0) return centers;
        if (lines.length % 2 === 1) {
            centers.centerAB = this.createPlanningLineAB(lines[Math.floor(lines.length / 2)], reference);
        } else {
            centers.centerAB1 = this.createPlanningLineAB(lines[lines.length / 2 - 1], reference);
            centers.centerAB2 = this.createPlanningLineAB(lines[lines.length / 2], reference);
        }
        return centers;
    };

    createPlanningPattern = (lines, abs, selectedABBack, selectedAB, type = 'BACKTOBACK', options = {}) => {
        if (!Array.isArray(lines) || !abs) return { lines: [], orderedLines: [], ab: null, ABs: abs };
        const indexed = lines.map(item => Object.assign({}, item, {
            planningIndex: item.planningIndex === undefined ? Math.abs(Number(item.key)) : item.planningIndex
        }));
        const centered = this.isCentralPlanningStrategy(type);
        const reference = selectedABBack === 1 && !centered
            ? (abs.mirroredAB || abs.endAB)
            : (abs.initialAB || abs.startAB);
        const ABs = Object.assign({}, abs, this.createPlanningCenterABs(indexed, reference));
        const ordered = this.orderPath(indexed, 0, type, null, Object.assign({}, options, { centerMirror: centered && selectedABBack === 1 }));
        const first = ordered[0];
        const central = [ABs.centerAB, ABs.centerAB1, ABs.centerAB2].find(value => value && first && value.line === first.planningIndex);
        const ab = (centered && central) || this.createPlanningLineAB(first, reference);
        const numbered = this.numberPlanningLines(indexed, ABs, selectedABBack, selectedAB, ab);
        const byIndex = new Map(numbered.map(item => [item.planningIndex, item]));
        return { lines: numbered, orderedLines: ordered.map(item => byIndex.get(item.planningIndex)), ab, ABs };
    };

    numberPlanningLines = (lines, abs, selectedABBack, selectedAB, referenceAB) => {
        if (!Array.isArray(lines) || !abs) return lines;
        const selected = referenceAB || (selectedABBack === 1
            ? (abs.mirroredAB || abs.endAB)
            : (abs.initialAB || abs.startAB));
        if (!selected || !Array.isArray(selected.c) || selected.c.length < 2) return lines;

        const ab = selectedAB === 1 ? selected.c : [selected.c[1], selected.c[0]];
        const [a, b] = ab.map(toMercatorCoordinate);
        const dx = b[0] - a[0];
        const dy = b[1] - a[1];
        if (!dx && !dy) return lines;

        return lines.map(item => {
            if (!item || !item.linhas) return item;
            const coordinate = turf.coordAll(item.linhas)[0];
            const index = item.planningIndex === undefined ? Math.abs(Number(item.key)) : item.planningIndex;
            const number = Math.abs(index - (Number(selected.line) || 0));
            if (!coordinate || !Number.isFinite(number)) return item;

            const point = toMercatorCoordinate(coordinate);
            const side = dx * (point[1] - a[1]) - dy * (point[0] - a[0]);
            return Object.assign({}, item, { key: number === 0 ? 0 : (side > 0 ? -number : number) });
        });
    };

    createPlanningLines = (polygon, abs, selectedABBack, faixa, exclusions = []) => {
        if (!abs) return [];
        const selected = selectedABBack === 1 ? abs.mirroredAB : abs.initialAB;
        if (!selected || !Array.isArray(selected.c)) return [];

        const frame = makePlanningFrame(polygon, selected.c);
        const width = Number(faixa);
        if (!frame || !Number.isFinite(width) || width <= 0) return [];

        const coordinates = selected.c.map(toMercatorCoordinate);
        const across = (frame.project(coordinates[0], frame.n) + frame.project(coordinates[1], frame.n)) / 2;
        const centerAcross = (frame.minAcross + frame.maxAcross) / 2;
        const direction = across <= centerAcross ? 1 : -1;
        const widthMercator = width * frame.mercatorScale;
        const maxSteps = Math.ceil((frame.maxAcross - frame.minAcross) / widthMercator) + 1;
        const lines = [];

        for (let step = 0; step <= maxSteps; step++) {
            const offsetAcross = across + direction * step * widthMercator;
            if (offsetAcross < frame.minAcross - widthMercator / 2 || offsetAcross > frame.maxAcross + widthMercator / 2) break;

            const line = makeLineAtProjection(frame, offsetAcross, widthMercator);
            const inside = getLinePiecesInsidePolygon(line, polygon);
            const clipped = removeExclusionPieces(inside, exclusions);
            if (clipped.length > 0) {
                lines.push({
                    linhas: turf.featureCollection(clipped),
                    key: step,
                    planningIndex: step
                });
            }
        }

        return lines;
    };

}

const tools = new Tools();

export default tools;
